import { useState } from "react";
import SectionTitle from "../common/SectionTitle";
import SeoHelper from "../common/SeoHelper";
import { galleryImages } from "../data/galleryImages";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Gallery = () => {
  const images = galleryImages;
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <>
      <SeoHelper />

      <section className="pt-24 pb-20 bg-gradient-to-br from-gray-100 to-gray-300">
        <div className="max-w-7xl mx-auto px-4">
          <SectionTitle
            title="Gallery"
            subtitle="A glimpse of Floret Town"
          />

          {/* MAIN SLIDER */}
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={30}
            loop={true}
            navigation={true}     // Default buttons (same as before)
            pagination={{
              clickable: true,
              el: ".gallery-pagination",
            }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            className="mt-12"
          >
            {images.map((img, index) => (
              <SwiperSlide key={img.id}>
                <div
                  onClick={() => setActiveIndex(index)}
                  className="cursor-pointer rounded-xl overflow-hidden shadow-lg group"
                >
                  <img
                    src={img.src}
                    alt="Gallery"
                    className="w-full h-[320px] object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* PAGINATION UNDER CARDS */}
          <div className="gallery-pagination flex justify-center mt-8" />
        </div>
      </section>

      {/* FULLSCREEN SLIDER */}
      {activeIndex !== null && (
        <div className="fixed inset-0 z-[999] bg-black/95 flex items-center justify-center">
          <button
            className="absolute top-5 right-6 text-white text-4xl font-bold z-50"
            onClick={() => setActiveIndex(null)}
          >
            ✕
          </button>

          <Swiper
            modules={[Navigation]}
            loop={true}
            navigation={true}      // Default buttons (same as before)
            initialSlide={activeIndex}
            slidesPerView={1}
            className="w-full h-full"
          >
            {images.map((img) => (
              <SwiperSlide key={img.id}>
                <div className="w-full h-full flex items-center justify-center">
                  <img
                    src={img.src}
                    alt="Gallery Fullscreen"
                    className="max-w-[90vw] max-h-[90vh] object-contain"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </>
  );
};

export default Gallery;







// import { useEffect, useMemo, useState } from "react";
// import { useLocation } from "react-router-dom";
// import GalleryImage from "../components/GalleryImage";
// import SectionTitle from "../common/SectionTitle";
// import { galleryImages } from "../data/galleryImages";
// import SeoHelper from '../common/SeoHelper';



// const categories = ["Exterior","Layout", "Lifestyle"]; // To Interior : just add Keyword in categories array

// const Gallery = () => {
//   const location = useLocation();
//   const params = new URLSearchParams(location.search);
//   const categoryFromURL = params.get("category");

//   const [activeImage, setActiveImage] = useState(null);
//   const [activeCategory, setActiveCategory] = useState(categoryFromURL || "Exterior");

//   // if user changes url manually
//   useEffect(() => {
//     if (categoryFromURL && categories.includes(categoryFromURL)) {
//       setActiveCategory(categoryFromURL);
//     }
//   }, [categoryFromURL]);

//   const filteredImages = useMemo(
//     () => galleryImages.filter((img) => img.category === activeCategory),
//     [activeCategory]
//   );

//   const currentIndex = activeImage
//     ? filteredImages.findIndex((img) => img.id === activeImage.id)
//     : -1;

//   const prevImage = () => {
//     if (currentIndex > 0) setActiveImage(filteredImages[currentIndex - 1]);
//   };

//   const nextImage = () => {
//     if (currentIndex < filteredImages.length - 1)
//       setActiveImage(filteredImages[currentIndex + 1]);
//   };

//   return (
//     <>
//     <SeoHelper/>
//     <section id="gallery" className="pt-24 pb-20 bg-gradient-to-br from-gray-300 to-emerald-300">
//       <div className="max-w-7xl mx-auto px-4">
//         <SectionTitle
//           title="Gallery"
//           subtitle="Experience the beauty of Floret Town"
//         />

//         {/* Category Tabs */}
//         <div className="flex gap-3 flex-wrap mb-10">
//           {categories.map((cat) => (
//             <button
//               key={cat}
//               className={`px-5 py-2 rounded-full font-semibold ${
//                 activeCategory === cat
//                   ? "bg-emerald-700 text-white"
//                   : "bg-white text-gray-800"
//               }`}
//               onClick={() => setActiveCategory(cat)}
//             >
//               {cat}
//             </button>
//           ))}
//         </div>

//         {/* Masonry container */}
//         <div className="columns-1 sm:columns-2 lg:columns-3 gap-6">
//           {filteredImages.map((img) => (
//             <GalleryImage
//               key={img.id}
//               src={img.src}
//               aspect={img.tailwindAspect}
//               type={img.category}
//               onClick={() => setActiveImage(img)}
//             />
//           ))}
//         </div>
//       </div>

//       {/* Fullscreen Preview */}
//       {activeImage && (
//         <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center">
//           <button
//             className="absolute top-5 right-5 text-white text-3xl font-bold z-50"
//             onClick={() => setActiveImage(null)}
//           >
//             ✕
//           </button>

//           <button
//             className="absolute left-5 text-white text-3xl font-bold z-50"
//             onClick={prevImage}
//             disabled={currentIndex === 0}
//           >
//             ‹
//           </button>

//           <button
//             className="absolute right-5 text-white text-3xl font-bold z-50"
//             onClick={nextImage}
//             disabled={currentIndex === filteredImages.length - 1}
//           >
//             ›
//           </button>

//           <img
//             src={activeImage.src}
//             alt={activeImage.category}
//             className="max-w-[90vw] max-h-[90vh] object-contain"
//           />
//         </div>
//       )}
//     </section>
//     </>
//   );
// };

// export default Gallery;
